<template>
	<a-select :value="selectValue" :mode="multiple ? 'multiple' : 'default'" :placeholder="placeholder" :style="{'min-width':'200px'}" @change="select">
		<a-select-option :key="'group'">
			Grupo
		</a-select-option>
		<a-select-option :key="'store'">
			Tienda
		</a-select-option>
		<a-select-option :key="'brand'">
			Marca
		</a-select-option>
		<a-select-option :key="'category'">
			Categoria
		</a-select-option>
		<a-select-option :key="'hashtag'">
			Hashtag
		</a-select-option>
	</a-select>
</template>

<script>
export default {
	props: {
		value: {
			type: [Array, String],
			default: null,
		},
		multiple: {
			type: Boolean,
			default: false,
		},
		placeholder: {
			type: String,
			default: 'Filtrar por tipo',
		},
	},
	emits: ['input'],
	computed: {
		selectValue() {
			return this.value;
		},
	},
	methods: {
		select(key) {
			this.$emit('input', key);
		},
	},
};
</script>

<style lang="scss" scoped>

</style>
